import { createPartyRequest } from './helper';
export const getPartiesByIban = createPartyRequest({
    route: '/party/parties/iban',
    method: 'get',
    source: 'data',
});
